export default {
  methods: {
    getBranch (getRecord) {
      var c = JSON.parse(localStorage.user)
      var pageUrl = ''
      this.$axios
      .get('branch?status=active&all=all', {
        headers: { Authorization: 'Bearer ' + localStorage.token }
      })
      .then((response) => response.data)
      .then((data) => {
        var branchRecord = []
        branchRecord = data.data
        if (branchRecord.length === 1) {
          this.branch = branchRecord[0]
          if (c.role.name === 'Agent' || c.role.name === 'Field Officer') {
            pageUrl += `agent/group?all=all&agent_id=${c.agent_profile.user_id}`
          } else {
            pageUrl += 'collectioncenter?all=all'
          }
          if (this.branch) {
            pageUrl += `&branch_id=${this.branch.id}`
          }
          this.$axios.get(pageUrl, {headers: { Authorization: 'Bearer ' + localStorage.token }})
          .then((response) => response.data)
          .then((data) => {
            this.colCenters = data.data
            _.forEach(this.colCenters, function (item, key) {
              this.colCenters[key].name = item.name + ' (' + item.centerCode + ')'
            }.bind(this))
            this.collectionCenters = this.colCenters
          })
          .catch(
            function (error) {
              Toast.fire({ icon: 'error', title: 'Please Try Againnnnn' })
              this.form.errors.errors = error.response.data.error
            }.bind(this)
          )
          if (getRecord === 'true') {
            this.loadStaff()
          }
          if (getRecord === 'branchLedgers') {
            this.getPaymentBranchLedgers()
          }
          if (getRecord === 'designation') {
            this.getBranchWiseRecord(this.branch)
          }
          if (getRecord === 'member') {
            this.getBranchWiseRecord(this.branch)
          }
        }
        this.branches = data.data
        console.log('=====branch length=========')
      })
      .catch(
        function (error) {
          Toast.fire({ icon: 'error', title: 'Please Try Again' })
          this.form.errors.errors = error.response.data.error
        }.bind(this)
      )
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/BranchRecords.js